export const SCANS_PER_YEAR: Record<string, number> = {
  daily: 365,
  weekly: 52,
  biweekly: 26,
  monthly: 12,
  quarterly: 4,
};

export function frequencyScaleFactor(
  historical: string,
  proposed: string
): number {
  const from = SCANS_PER_YEAR[historical];
  const to = SCANS_PER_YEAR[proposed];
  if (!from || !to || from === to) return 1;
  return to / from;
}

export function marginColor(margin: number | null): string {
  if (margin === null) return 'text-chariot-text-secondary';
  if (margin >= 90) return 'text-green-600';
  if (margin >= 50) return 'text-yellow-500';
  return 'text-red-500';
}
